import React, { Component } from 'react';
import AiImageBigWrap from './AiImageBigWrap';
import Sticky  from "react-sticky-el";
import AiOptionSetWrap from './AiOptionSetWrap';
import AiToolbarWrap from './AiToolbarWrap';
import {OPTION_URL} from '../constants';
//import {Button} from 'primereact/components/button/Button';
function callback(status) {
    //console.log('callback status',status);
  }  
class MainBodyPortrait extends Component {
    
    render() {
        //console.log('MAIN BODY PORTRAIT render',this.props.showSticky);
        return (<div  className='ai-body'> 
        <div className='ai-cfg-small'>{this.props.cfg}</div>
        <div className='ai-title-small'>{this.props.title}</div>
     
     
       <Sticky  topOffset={0}  className='ai-sticky' disabled={this.props.showSticky} 
       onFixedToggle={callback} > 
       <i className='ai-startover-small'
        onClick={this.props.onStartOver}>
        <img className="ai-startover-button" 
        src={OPTION_URL + "small/button/so3.png"} alt=""
        srcSet={OPTION_URL + "small/button/so3.png 1x, " +OPTION_URL + "large/button/so3.png 2x"}
        />
        </i>
        <i className='ai-zoom-small' >
        <img className="ai-zoom-button" 
        src={OPTION_URL + "small/button/z3.png"} 
        srcSet={OPTION_URL + "small/button/z3.png 1x, " +OPTION_URL + "large/button/z3.png 2x"}
        onClick={this.props.onPushOpenBox}
        alt=""/>
        </i> 
        <AiImageBigWrap 
        size={this.props.size} 
        className='ai-image-portrait' 
        orientation={this.props.orientation}/>
        <AiToolbarWrap className='ai-toolbar-panel' size={this.props.size}  optionNumber={this.props.optionNumber} />
        </Sticky>
        <div className='ai-all-options'>
            <AiOptionSetWrap 
            optionNumber={this.props.optionNumber} 
            optionSize={this.props.optionSize}/>
        </div>
        
        </div>
        );
    }
}


export default MainBodyPortrait;


// WEBPACK FOOTER //
// ./src/layout/MainBodyPortrait.js